import type { TemplateEntryDef, TemplateEntryField } from '@vivport/backend/types';

export interface EntryFieldGroup {
  group: string | null;
  fields: TemplateEntryField[];
}

// Presentation order only: ungrouped fields first, then each group in order of first appearance,
// which is the order the backend composes the block in.
export function groupFieldsInDefOrder(def: TemplateEntryDef): EntryFieldGroup[] {
  const ungrouped = def.fields.filter((field) => field.group === undefined);
  const groups: EntryFieldGroup[] = ungrouped.length > 0 ? [{ group: null, fields: ungrouped }] : [];
  const byGroup = new Map<string, TemplateEntryField[]>();
  for (const field of def.fields) {
    if (field.group === undefined) continue;
    const list = byGroup.get(field.group) ?? [];
    list.push(field);
    byGroup.set(field.group, list);
  }
  for (const [group, fields] of byGroup) {
    groups.push({ group, fields });
  }
  return groups;
}
